// shared-components/context/ToastContext.jsx
import { createContext, useContext } from "react";
import PropTypes from "prop-types";
import {
  useToast as useToastHook,
  ToastContainer,
} from "@shared/components/feedback/Toast";

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const { toasts, toast } = useToastHook();

  return (
    <ToastContext.Provider value={{ toast }}>
      <ToastContainer toasts={toasts} />
      {children}
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// eslint-disable-next-line react-refresh/only-export-components
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
